var sidebar = jQuery(".sidebar");
var appaResources = jQuery(".appa-resources");

if (sidebar.length && appaResources.length) {
    var stickyTop = sidebar.offset().top;
    var footer = appaResources.offset().top;

    jQuery(window).on("scroll", function () {
        if (jQuery(window).scrollTop() >= stickyTop) {
            jQuery("body").addClass("sticky-sidebar");
        } else {
            jQuery("body").removeClass("sticky-sidebar");
        }
        if (jQuery(window).scrollTop() + 2000 >= footer) {
            jQuery("body").removeClass("sticky-sidebar");
        }
    });
} 